/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react"

import Header from "components/Header"
import Footer from "components/Footer"

import PersonTable from "components/tables/PersonTable"
import PreglediTable from "components/tables/PreglediTable"
import PodatkiTable from "components/tables/PodatkiTable"
import ZgodovinaTable from "components/tables/ZgodovinaTable"

import DetailSidebar, { DetailActions } from "./DetailSidebar"
import { VehicleIcon } from "components/CarButton"

// eslint-disable-next-line no-unused-vars
import { ReactComponent as InfoSVG } from "assets/Icon/Info.svg"
import { ReactComponent as PersonSVG } from "assets/Icon/Person.svg"
import { ReactComponent as HistorySVG } from "assets/Icon/History.svg"
import { ReactComponent as ChevronUpSVG } from "assets/Icon/Chevron Up.svg"
import { ReactComponent as ChevronDownSVG } from "assets/Icon/Chevron Down.svg"
import { ReactComponent as ChevronRightSVG } from "assets/Icon/Chevron Right.svg"
import { ReactComponent as PrintSVG } from "assets/Icon/Print.svg"
import { ReactComponent as ProblemSVG } from "assets/Icon/Problem.svg"

import demoCarData from "./carData.json"

import "./Detail.sass"
import { useParams } from "react-router-dom"

const Detail = () => {
  const is_stolen = Math.random() > 0.9
  const is_anomalous = Math.random() > 0.75
  const is_corrected = Math.random() > 0.5

  const { vin } = useParams();

  return (
    <>
      <script id="car_data" type="application/json">
        {JSON.stringify(demoCarData)}
      </script>

      <div id="header-root" className="isDetail">
        <Header isSlim isDetail searchValue={vin} />
      </div>

      <div className="Detail">
        <div className="content-container">
          <div className="detail-content">
            <div className="name full">
              <h2 className={is_stolen ? "is_stolen" : undefined}>
                <span className="label">
                  <img src="/placeholders/peugeot.png" alt="Peugeot" /> PEUGEOT
                  407 / BREAK 2.0 / HDI
                </span>

                {is_stolen ? (
                  <span className="badge-with-tooltip danger stolen">
                    <ProblemSVG /> {/*<span>Ukradeno</span>*/}
                  </span>
                ) : is_anomalous ? (
                    <span className="badge-with-tooltip danger anomalous">
                    <ProblemSVG /> {/*<span>Ukradeno</span>*/}
                  </span>
                ) : is_corrected ? (
                  <span className="badge-with-tooltip notice corrected">
                    <ProblemSVG />
                  </span>
                ) : (
                  <span className="badge-with-tooltip warning tehnicni">
                    <ProblemSVG />
                  </span>
                )}

                {false && (
                  <span className="badge-with-tooltip warning">
                    <ProblemSVG />
                  </span>
                )}

                {false && is_anomalous && (
                  <span className="badge-with-tooltip danger">
                    <HistorySVG /> <span>Anomalije</span>
                  </span>
                )}

                <div className="grow" />

                <a href="/print" className="print">
                  <PrintSVG /> <span>Natisni</span>
                </a>
              </h2>
            </div>

            {is_stolen && (
              <div className="Stolen">
                <h3>POZOR: VOZILO JE V BAZI UKRADENIH VOZIL!</h3>
                <p className="description">
                  Vozilo z identifikacijsko številko (VIN){" "}
                  <b>ZFA31200000518472</b> in registrsko številko <b>LJKC269</b>{" "}
                  je bilo ukradeno <b>21. 03. 2019</b>.
                  <br />
                  <a
                    href="https://www.policija.si/seznami/ukradenavozila/uv_prikaz.php"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Baza ukradenih vozil
                    <ChevronRightSVG />
                  </a>
                </p>
              </div>
            )}

            <DetailActions />

            <div className="charts">
              <div className="chart-container">
                <h3 className={is_anomalous ? "danger" : undefined}>
                  Število prevoženih kilometrov
                </h3>
                <img
                  className="chart"
                  src="/placeholders/Chart - Kilometers.svg"
                  alt="Prevoženi kilometri"
                />
              </div>
              <div className="chart-container">
                <h3>Starost lastnika</h3>
                <img
                  className="chart"
                  src="/placeholders/Chart - Owner Age.svg"
                  alt="Starost lastnika"
                />
              </div>
              {/* <div className="stats-1">
              <h3>Statistika</h3>
              <table>
                <tbody>
                <tr>
                  <th>Prvi priklic na Avtologu</th>
                  <td>15. marec, 2018</td>
                </tr>
                <tr>
                  <th>Število ogledov</th>
                  <td>4.328</td>
                </tr>
                </tbody>
              </table>
            </div>
            */}
            </div>

            <div className="car-data">
              <div className="toc-container">
                <ul className="toc">
                  <li>
                    <a href="#podatki">Podatki o vozilu</a>
                  </li>
                  <li>
                    <a href="#tehnicni">Tehnični pregledi</a>
                  </li>
                  <li>
                    <a href="#lastnik">Podatki o lastniku</a>
                  </li>
                  <li>
                    <a href="#zgodovina">Zgodovina</a>
                    <span>
                      <a href="#year-2019">2019</a>
                      <a href="#year-2018">2018</a>
                      <a href="#year-2015">2015</a>
                      <a href="#year-2014">2014</a>
                    </span>
                  </li>
                </ul>
              </div>

              <div className="accordion">
                <a className="toc-anchor" id="podatki" />

                <div className="pane expanded">
                  <h3 className="title active">
                    <VehicleIcon
                      vehicle_type={demoCarData.vehicle_type}
                      className="icon"
                    />{" "}
                    Podatki o vozilu
                    <div className="grow" />
                    <ChevronDownSVG className="chevron" />
                  </h3>
                  <div className="content">
                    <PodatkiTable />
                  </div>
                </div>

                <a className="toc-anchor" id="tehnicni" />

                <div className="pane expanded">
                  <h3 className="title">
                    {/* <InfoSVG className="icon" /> */}
                    <ProblemSVG className="warning" />
                    <span>Tehnični pregledi</span>
                    <div className="grow" />
                    <ChevronUpSVG className="chevron" />
                  </h3>
                  <div className="content">
                    <PreglediTable />
                  </div>
                </div>

                <a className="toc-anchor" id="lastnik" />

                <div className="pane expanded">
                  <h3 className="title">
                    <PersonSVG className="icon" /> Podatki o lastniku
                    <div className="grow" />
                    <ChevronUpSVG className="chevron" />
                  </h3>
                  <div className="content">
                    <PersonTable />
                  </div>
                </div>

                <a className="toc-anchor" id="zgodovina" />

                <div className="pane expanded">
                  <h3 className="title">
                    <HistorySVG className="icon" /> Zgodovina
                    <div className="grow" />
                    <ChevronUpSVG className="chevron" />
                  </h3>
                  <div className="content">
                    <ZgodovinaTable />
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="stats-2">
            <h3>Statistika</h3>
            <table>
              <tr>
                <th>Prvi priklic</th>
                <td>15. marec, 2018</td>
              </tr>
              <tr>
                <th>Število ogledov</th>
                <td>4.328</td>
              </tr>
            </table>
          </div> */}
          </div>

          <div id="sidebar-root">
            <DetailSidebar />
          </div>

          {/* <div className="history-content row">
          <div className="full">
          <SearchHistory />
          </div>
        </div> */}
        </div>
      </div>

      <div id="footer-root">
        <Footer />
      </div>
    </>
  )
}

export default Detail
